import ConditionType from './ConditionType'

const EqualsCondition: ConditionType = {
  value: 'equals',
  label: 'Equals',
  hasRHS: true,
}

export default EqualsCondition
